import { forwardRef, PropsWithChildren } from 'react';
import * as SC from './styles';
import { IBoxProps } from './types';
const Box = forwardRef<HTMLDivElement, PropsWithChildren<IBoxProps>>(
  ({ children, ...rest }, ref) => {
    return (
      <SC.Container ref={ref} style={{ ...rest }}>
        {children}
      </SC.Container>
    );
  }
);

export default Box;
